// Wykrywanie sterownika do parowania w tle (docs/pwa/NATYWNA.md 4, krok 2b) - aplikacja ze sklepu na Androidzie,
// wtyczka natywna `Wykrywanie` (telefon/android .../Wykrywanie.java). Telefon sam słyszy sterownik w oknie parowania
// i porównuje jego numer z listą sztuk konta; obcy numer = powiadomienie „czeka na parowanie”, dotknięcie = kreator
// z tą sztuką (`/urzadzenia/dodaj?sn=`). APP podaje liście numery po wczytaniu składu i teksty w języku konta.
// Przełącznik „Szukaj nowych urządzeń w pobliżu” w Ustawieniach, domyślnie włączony. iPhone - później (NATYWNA.md 4).
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { Capacitor, registerPlugin, type PluginListenerHandle } from "@capacitor/core";
import { odswiezPush } from "../api/powiadomienia";
import { useSklad, useWczytana } from "../brama/uzyj";
import { t } from "../i18n/t";
import { natywna } from "./instalacja";

interface StanWykrywania {
  wlaczone: boolean;
  zgody: boolean;
}

interface WtyczkaWykrywania {
  ustaw(o: { numery: string[]; teksty: { kanal: string; tytul: string; tresc: string }; wlaczone?: boolean; pytaj?: boolean }): Promise<StanWykrywania & { dziala: boolean }>;
  zatrzymaj(): Promise<void>;
  stan(): Promise<StanWykrywania>;
  addListener(zdarzenie: "parowanie", f: (e: { sn: string }) => void): Promise<PluginListenerHandle>;
}

const W = registerPlugin<WtyczkaWykrywania>("Wykrywanie");

/** Jest wykrywanie na tym telefonie (aplikacja ze sklepu na Androidzie). */
export const maWykrywanie = () => natywna() && Capacitor.getPlatform() === "android";

let numery: string[] = [];

const teksty = () => ({ kanal: t("Nowe urządzenia w pobliżu"), tytul: t("Nowe urządzenie w pobliżu"),
  tresc: t("{nazwa} czeka na parowanie - dotknij, żeby dodać.") });

/** Ustawienie wtyczki: bieżące numery konta i teksty; `wlaczone` - zmiana przełącznika (z prośbą o zgody). */
export function ustawWykrywanie(wlaczone?: boolean) {
  return W.ustaw({ numery, teksty: teksty(), wlaczone, pytaj: wlaczone === true });
}

export const stanWykrywania = () => W.stan();

/** W powłoce po zalogowaniu: lista sztuk konta do wtyczki (po wczytaniu składu - inaczej pusta lista = powiadomienia
 *  o własnych sterownikach), dotknięte powiadomienie → kreator, wylogowanie → skan stoi. */
export function useWykrywanieUrzadzen() {
  const idz = useNavigate();
  const sklad = useSklad();
  const wczytana = useWczytana();
  const lista = sklad.map((d) => d.sn).sort().join(",");
  useEffect(() => {
    if (!maWykrywanie() || !wczytana) return;
    numery = lista ? lista.split(",") : [];
    // Pierwszy start pyta tu o zgodę na powiadomienia - po niej od razu token pushu na konto (nie dopiero przy
    // następnym starcie).
    void ustawWykrywanie().then(() => odswiezPush(), () => undefined);
  }, [wczytana, lista]);
  // useNavigate zmienia się przy przejściach - nasłuch i wylogowanie tylko raz na powłokę.
  const idzRef = useRef(idz);
  useEffect(() => { idzRef.current = idz; });
  useEffect(() => {
    if (!maWykrywanie()) return;
    // Starsza aplikacja (paczka APP bez nowej części natywnej) nie ma wtyczki - wszystko tu po cichu odpada.
    const n = W.addListener("parowanie", (e) => void idzRef.current("/urzadzenia/dodaj?sn=" + encodeURIComponent(e.sn))).catch(() => null);
    return () => {
      void n.then((h) => h?.remove());
      void W.zatrzymaj().catch(() => undefined);
    };
  }, []);
}
